export default {
    format: String,
    max: Date,
    min: Date,
    value: String | Date,
    messages: Object,

    // Events
    change: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoDateInput/DateInputProps.js